import { DynamicYieldService } from './dynamicYield.service';
import { NotificationsService } from './notifications.service';
import {
  PreQualFormEventConstant,
  FormAndProcessActualName,
  DynamicYieldEventName,
  PersonalDetailsPrequalUDOConstants
} from './../enum/analytics.enum';
import { IConfirmationClickEvent, IPreQualEvent } from './../interfaces/analytics.interface';
import { Inject, Injectable } from '@angular/core';
import { UDO } from '../../global';
import {
  CategoryL1, CategoryL2, CategoryL3, FormActualName,
  UDOConstant, CreditAppUDOConstants, EventLabel, FormNumber,
  CategoryL4, EventCategory, EventAction, EditEvent, ErrorType, FormName
} from '../enum/analytics.enum';
import { ComponentName } from '../enum/component-name.enum';
import { TealiumService } from './tealium.service';
import { AnalyticsEventService } from './analytics-event.service';
import { AnalyticsActionTypes, Actions } from '../actions/analytics.action';
import { CreditApplication } from '../../lib/interfaces/credit-application.interface';
import { IAnalyticsErrorResponse } from '../interfaces/analytics.interface';
import { IConfig } from '../interfaces/config.interface';
import { INotification, NotificationType } from '../interfaces/notification.interface';
import { CreditAppService } from './credit-app.service';


@Injectable({
  providedIn: 'root'
})
export class FormInfoService {

  formStarted = false;
  formStart = false;
  isBuyNow = false;
  isNewVDP: boolean = false;
  // tslint:disable-next-line: variable-name
  category_l1: string = UDO.NotSet;
  // tslint:disable-next-line: variable-name
  category_l2: string = UDO.NotSet;
  // tslint:disable-next-line: variable-name
  category_l3: string = UDO.NotSet;
  // tslint:disable-next-line: variable-name
  category_l4: string = UDO.NotSet;

  // tslint:disable-next-line: variable-name
  form_actual_name: string = UDO.NotSet;
  // tslint:disable-next-line: variable-name
  process_actual_name: string = CreditAppUDOConstants.ProcessActualName;
  // tslint:disable-next-line: variable-name
  process_name: string = CreditAppUDOConstants.ProcessName;
  coBuyer = false;

  constructor(public tealium: TealiumService,
              analyticsEventService: AnalyticsEventService,
              @Inject('config') public config: IConfig,
              public notificationService: NotificationsService,
              public dynamicYieldService: DynamicYieldService,
              public creditAppService: CreditAppService) {
    this.setCategoryL1();
    this.setCategoryL2();
    this.setCategoryL4();
    
    this.isNewVDP = window.location.search.toLowerCase().indexOf('?isnewvdp=true') === -1 ? false : true;


    this.notificationService.notificationBroadcasted$.subscribe((n: INotification) => {
      if (n !== null && n.Type === NotificationType.coBuyerActivation) {
        this.coBuyer = true;
      } else if (n !== null && n.Type === NotificationType.coBuyerDeactivation) {
        /* istanbul ignore next */
        this.coBuyer = false;
      }
    });
    analyticsEventService.analyticsEvent$.subscribe(action => {

      if (action !== null) {
        switch (action.type) {
          case AnalyticsActionTypes.ComponentLoaded:
            if (this.config && this.config.Sitecore && this.config.Sitecore.isBuyNow) {
            this.isBuyNow = this.config.Sitecore.isBuyNow || false;
            this.setCategoryL3L4AndFormActualName(action);
            }
            break;
          case AnalyticsActionTypes.NextCTAClick:
            /* istanbul ignore next */
            if (!this.isBuyNow) {
              console.log(AnalyticsActionTypes.NextCTAClick);
              this.reportFormPageNSubmit();
            }
            /* istanbul ignore next */
            break;
          case AnalyticsActionTypes.FormStarted:
            console.log(AnalyticsActionTypes.FormStarted);
            this.reportFormStarted();
            break;
          case AnalyticsActionTypes.SubmitInitiated:
            console.log(AnalyticsActionTypes.SubmitInitiated);
            this.reportSubmitInitiated();
            break;
          case AnalyticsActionTypes.LeadDataSubmit:
            if (!this.isBuyNow) {
              console.log(AnalyticsActionTypes.LeadDataSubmit);
              this.reportLeadFormData(action.payload.data);
            }
            break;
          case AnalyticsActionTypes.FormSuccess:
            console.log(AnalyticsActionTypes.FormSuccess);
            this.reportSubmitStatus(true);
            break;
          case AnalyticsActionTypes.FormFailure:
            console.log(AnalyticsActionTypes.FormFailure);
            this.reportSubmitStatus(false);
            break;
          case AnalyticsActionTypes.EditCTAClick:
            console.log(AnalyticsActionTypes.EditCTAClick);
            this.reportEditCTAClick(action);
            break;
          case AnalyticsActionTypes.SubmitApplication:
            if (!this.isBuyNow) {
              console.log(AnalyticsActionTypes.SubmitApplication);
              this.reportSubmitApplication();
            }
            break;
          case AnalyticsActionTypes.UnlockCreditApp:
            console.log(AnalyticsActionTypes.UnlockCreditApp);
            this.reportUnlockCreditApp();
            break;
          case AnalyticsActionTypes.CreateNewCreditApp:
            console.log(AnalyticsActionTypes.CreateNewCreditApp);
            this.reportNewCreditApp();
            break;
          case AnalyticsActionTypes.ServerError:
            console.log(AnalyticsActionTypes.ServerError);
            this.reportServerError(action.data);
            break;
          case AnalyticsActionTypes.PreQualComponentLoaded:
            this.reportPreQualComponentLoaded(action.payload);
            break;
          case AnalyticsActionTypes.PreQualConfirmationClickEvents:
            console.log('Prequal component Load', action.payload);
            this.reportClickEventForPrequalConfirmation(action.payload);
            break;
          case AnalyticsActionTypes.PreQualFormEvents:
            console.log(action.payload.type);
            this.reportPrequalFormEvent(action.payload);
            break;
          case AnalyticsActionTypes.PreQualConfirmationComponentLoaded:
            console.log(action.payload.type);
            this.reportPrequalFormEvent(action.payload);
            break;
          case AnalyticsActionTypes.ContactStoreComponentLoaded:
            console.log(action.payload.type);
            this.reportContactStoreComponentLoaded(action.payload);
            if(action.payload.isConfirm != true) {
              this.reportContactStoreFormLoaded(action.payload);
            }
        }
      }
    }
    );
  }

  reportPrequalFormEvent(data: IPreQualEvent) {
    try {
      this.category_l1 = CategoryL1.Finance;
      this.category_l2 = CategoryL2.PreQual;
      this.category_l3 = data.isVinAvailable ? UDO.VIN : UDO.NO_VIN;
      this.category_l4 = UDO.NotSet;
      const preQualFormEvent: any = {};
      preQualFormEvent.category_l1 = this.category_l1;
      preQualFormEvent.category_l2 = this.category_l2;
      preQualFormEvent.category_l3 = this.category_l3;
      preQualFormEvent.category_l4 = this.category_l4;
      switch (data.type) {
        case PreQualFormEventConstant.FormStarted:
          preQualFormEvent.form_name = FormName.PreQualForm;
          preQualFormEvent.form_actual_name = FormActualName.PreQualForm;
          preQualFormEvent.form_started = UDOConstant.UnityFlag;
          preQualFormEvent.event = EditEvent.FormStarted;
          preQualFormEvent.event_category = EventCategory.LeadSubmission;
          preQualFormEvent.event_action = EventAction.EngagementTypePrequalFormStarted;
          preQualFormEvent.event_label = EventLabel.PreQualFormStarted;
          preQualFormEvent.event_value = UDOConstant.UnityFlag;
          preQualFormEvent.pagegroup = UDOConstant.preQualPageGroup;
          break;
        case PreQualFormEventConstant.FormSubmitInitiated:
          preQualFormEvent.form_name = FormName.PreQualForm;
          preQualFormEvent.form_actual_name = FormActualName.PreQualForm;
          preQualFormEvent.submit_initiated = UDOConstant.UnityFlag;
          preQualFormEvent.event = EditEvent.FormSubmitInitiated;
          preQualFormEvent.event_category = EventCategory.LeadSubmission;
          preQualFormEvent.event_action = EventAction.EngagementTypePrequalFormSubmitInitiated;
          preQualFormEvent.event_label = EventLabel.PreQualFormSubmitInitiated;
          preQualFormEvent.event_value = UDOConstant.UnityFlag;
          preQualFormEvent.pagegroup = UDOConstant.preQualPageGroup;
          break;
        case PreQualFormEventConstant.FormSuccess:
          preQualFormEvent.form_name = FormName.PreQualForm;
          preQualFormEvent.form_actual_name = FormActualName.PreQualForm;
          preQualFormEvent.form_success = UDOConstant.UnityFlag;
          preQualFormEvent.event = EditEvent.FormSuccess;
          preQualFormEvent.event_category = EventCategory.LeadSubmission;
          preQualFormEvent.event_action = EventAction.EngagementTypePrequalFormSuccess;
          preQualFormEvent.event_label = EventLabel.PreQualFormSuccess;
          preQualFormEvent.event_value = UDOConstant.UnityFlag;
          preQualFormEvent.pagegroup = UDOConstant.preQualPageGroup;
          /* istanbul ignore next */
          if (data.isStandAlonePrequal === true) {
            preQualFormEvent.category_l4 = '(not set)';
          }
          if(this.isNewVDP) {
            this.dynamicYieldService.track(DynamicYieldEventName.FormSuccessVDPPrequal, preQualFormEvent);
          } else {
            this.dynamicYieldService.track(DynamicYieldEventName.FormSuccessPersonalDetails, preQualFormEvent);
          }
          
          //preQualFormEvent.prequal_amount = data.data.prequalAmt > 0 ? data.data.prequalAmt : UDO.NotSet;
          break;
        case PreQualFormEventConstant.LeadSubmission:
          preQualFormEvent.form_name = FormName.PreQualForm;
          preQualFormEvent.form_actual_name = FormActualName.PreQualForm;
          preQualFormEvent.event = EditEvent.LeadSubmission;
          preQualFormEvent.event_category = EventCategory.LeadSubmission;
          preQualFormEvent.event_action = EventAction.EngagementTypePrequalLeadSubmission;
          preQualFormEvent.event_label = EventLabel.PreQualLeadSubmission;
          preQualFormEvent.event_value = UDOConstant.UnityFlag;
          preQualFormEvent.pagegroup = UDOConstant.preQualPageGroup;
          /* istanbul ignore next */
          preQualFormEvent.lead_cust_zip = data.data.zipcode ? data.data.zipcode : this.GetCustZipcode();
          preQualFormEvent.lead_submission = 1;
          /* istanbul ignore next */
          if (data.isVinAvailable) {
            preQualFormEvent.lead_vin = data.data.vin;
            preQualFormEvent.lead_inv_type = data.data.inventoryType;
            preQualFormEvent.lead_make = data.data.make;
            preQualFormEvent.lead_make_yr = data.data.year;
            preQualFormEvent.lead_make_model = data.data.model;
            preQualFormEvent.lead_hyperion = data.data.HyperianId;
          }

          break;
        case PreQualFormEventConstant.FormFailure:
          preQualFormEvent.form_name = FormName.PreQualForm;
          preQualFormEvent.form_actual_name = FormActualName.PreQualForm;
          preQualFormEvent.event = EditEvent.FormFailure;
          preQualFormEvent.form_failure = UDOConstant.UnityFlag;
          preQualFormEvent.event_category = EventCategory.LeadSubmission;
          preQualFormEvent.event_action = EventAction.EngagementTypePrequalLeadFailure;
          preQualFormEvent.event_label = EventLabel.PreQualFormFailure;
          preQualFormEvent.event_value = UDOConstant.UnityFlag;
          preQualFormEvent.pagegroup = UDOConstant.preQualPageGroup;
          break;
        case PreQualFormEventConstant.PreQualApproved:
          preQualFormEvent.form_name = FormName.PreQualForm;
          preQualFormEvent.form_actual_name = FormActualName.PreQualForm;
          preQualFormEvent.event = EditEvent.ApprovedPrequal;
          preQualFormEvent.event_category = EventCategory.LeadSubmission;
          preQualFormEvent.event_action = EventAction.EngagementTypePrequalApproved;
          preQualFormEvent.event_label = EventLabel.PrequalApproved;
          preQualFormEvent.event_value = UDOConstant.UnityFlag;
          preQualFormEvent.pagegroup = UDOConstant.preQualPageGroup;
          if (data.data.prequalAmt) {
            preQualFormEvent.prequal_amount = data.data.prequalAmt.toString();
          }
          break;
        case PreQualFormEventConstant.PreQualConfirmationLoaded:
          preQualFormEvent.event = EditEvent.PageLoad;
          preQualFormEvent.event_category = EventCategory.LeadSubmission;
          preQualFormEvent.event_action = EventAction.LeadSubmissionDigitalRetailingPageLoad;
          preQualFormEvent.event_label = EventLabel.PersonalDetailsPrequalPageLoad;
          preQualFormEvent.event_value = UDOConstant.UnityFlag;
          preQualFormEvent.pagegroup = UDOConstant.preQualPageGroup;
          preQualFormEvent.process_actual_name = PersonalDetailsPrequalUDOConstants.ProcessActualName;
          preQualFormEvent.process_name = PersonalDetailsPrequalUDOConstants.ProcessName;
          if (data.data.prequalAmt) {
            preQualFormEvent.prequal_amount = data.data.prequalAmt.toString();
          }
          break;
        case PreQualFormEventConstant.PreQualDeclined:
          preQualFormEvent.form_name = FormName.PreQualForm;
          preQualFormEvent.form_actual_name = FormActualName.PreQualForm;
          preQualFormEvent.event = EditEvent.DeclinedPrequal;
          preQualFormEvent.event_category = EventCategory.LeadSubmission;
          preQualFormEvent.event_action = EventAction.EngagementTypePrequalDenied;
          preQualFormEvent.event_label = EventLabel.PrequalDenied;
          preQualFormEvent.event_value = UDOConstant.UnityFlag;
          preQualFormEvent.pagegroup = UDOConstant.preQualPageGroup;
          break;
      }

      (window as any).utag_data = preQualFormEvent;
      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

     reportPreQualComponentLoaded(data: IPreQualEvent) {
    try {
      this.category_l1 = CategoryL1.Finance;
      this.category_l2 = CategoryL2.PreQual;
      this.category_l3 = data.isVinAvailable ? UDO.VIN : UDO.NO_VIN;
      this.category_l4 = UDO.NotSet;
      const preQualPageLoad: any = {};
      preQualPageLoad.category_l1 = this.category_l1;
      preQualPageLoad.category_l2 = this.category_l2;
      preQualPageLoad.category_l3 = this.category_l3;
      preQualPageLoad.category_l4 = this.category_l4;
      preQualPageLoad.event = 'page_view';
      preQualPageLoad.ip_address = UDO.NotSet;
      preQualPageLoad.page_view = '1';
      preQualPageLoad.page_version = '1';      
      preQualPageLoad.zipcode = data?.data?.zipcode || UDO.NotSet;
      preQualPageLoad.latitude = data?.data?.UserPreferredCoordinates?.Latitude || UDO.NotSet;
      preQualPageLoad.longitude = data?.data?.UserPreferredCoordinates?.Longitude || UDO.NotSet;
      (window as any).utag_data = preQualPageLoad;
      this.tealium.view((window as any).utag_data);
      setTimeout(() => {
        this.reportPreQualFormLoaded(data);
      }, 100);    
    } catch (error) {
      console.log(error);
    }
  }

  reportPreQualFormLoaded(data: IPreQualEvent) {
    try {
      this.category_l1 = CategoryL1.Finance;
      this.category_l2 = CategoryL2.PreQual;
      this.category_l3 = data.isVinAvailable ? UDO.VIN : UDO.NO_VIN;
      this.category_l4 = UDO.NotSet;
      const preQualPageLoad: any = {};
      preQualPageLoad.category_l1 = this.category_l1;
      preQualPageLoad.category_l2 = this.category_l2;
      preQualPageLoad.category_l3 = this.category_l3;
      preQualPageLoad.category_l4 = this.category_l4;
      preQualPageLoad.form_name = FormName.PreQualForm;
      preQualPageLoad.form_actual_name = FormActualName.PreQualForm;
      preQualPageLoad.form_page_load = UDOConstant.UnityFlag;
      preQualPageLoad.event = 'form_load';
      preQualPageLoad.ip_address = UDO.NotSet;
      preQualPageLoad.page_view = '1';
      preQualPageLoad.page_version = '1';      
      preQualPageLoad.zipcode = data?.data?.zipcode || UDO.NotSet;
      preQualPageLoad.latitude = data?.data?.UserPreferredCoordinates?.Latitude || UDO.NotSet;
      preQualPageLoad.longitude = data?.data?.UserPreferredCoordinates?.Longitude || UDO.NotSet;
      (window as any).utag_data = preQualPageLoad;
      this.tealium.link((window as any).utag_data);
      if(this.isNewVDP) {
        this.dynamicYieldService.reportFormLoadDY(FormActualName.vdpPrequalification,preQualPageLoad);
      } else {
        this.dynamicYieldService.reportFormLoadDY(DynamicYieldEventName.FormLoadPersonalDetails,preQualPageLoad);
      }
      
    } catch (error) {
      console.log(error);
    }
  }

  reportContactStoreComponentLoaded(data: any) {
    try {
      this.category_l1 = CategoryL1.Contact;
      this.category_l2 = CategoryL2.OEM;
      this.category_l3 = data.isConfirm ? 'Confirmation' : UDO.NotSet;
      this.category_l4 = UDO.NotSet;
      const preQualPageLoad: any = {};
      preQualPageLoad.category_l1 = this.category_l1;
      preQualPageLoad.category_l2 = this.category_l2;
      preQualPageLoad.category_l3 = this.category_l3;
      preQualPageLoad.category_l4 = this.category_l4;
      preQualPageLoad.condition = data.leftRailVehicleData.InventoryVehicleDetail.StockType;
      preQualPageLoad.enh_action = 'detail';
      preQualPageLoad.enh_vehic_brand = data.leftRailVehicleData.Make;
      preQualPageLoad.enh_vehic_id = data.leftRailVehicleData.Vin;
      preQualPageLoad.enh_vehic_name =  data.leftRailVehicleData.Year + " " + data.leftRailVehicleData.Make + " " + data.leftRailVehicleData.Model + " " + data.leftRailVehicleData.StyleName;;
      preQualPageLoad.enh_vehic_category = data.leftRailVehicleData.InventoryVehicleDetail.StockType;
      preQualPageLoad.enh_vehic_variant =  data.leftRailVehicleData.ExteriorColor || UDO.NotSet
      preQualPageLoad.hyperion_id = data.Hid;
      preQualPageLoad.inventory_status = this.getInventoryStatusString(data.leftRailVehicleData.InventoryVehicleDetail.InventoryStatus);
      preQualPageLoad.inventory_type = data.leftRailVehicleData.InventoryVehicleDetail.StockType;;
      preQualPageLoad.ip_address = UDO.NotSet;
      preQualPageLoad.latitude = data.UserPreferredCoordinates.Latitude;
      preQualPageLoad.longitude = data.UserPreferredCoordinates.Longitude;
      preQualPageLoad.make = data.leftRailVehicleData.Make;
      preQualPageLoad.make_yr = data.leftRailVehicleData.Year
      preQualPageLoad.manufacturer = data.leftRailVehicleData.Make;
     // preQualPageLoad.market_path = true;
      preQualPageLoad.mileage = data.leftRailVehicleData.Mileage;
      preQualPageLoad.model = data.leftRailVehicleData.Model;
      preQualPageLoad.pagegroup = CategoryL1.Contact.toLowerCase();
      preQualPageLoad.trim = data.leftRailVehicleData.Trim;
      preQualPageLoad.zipcode = data.LeadInfo.ZipCode;
      preQualPageLoad.vin= data.leftRailVehicleData.Vin;
      preQualPageLoad.event = 'page_view';
      preQualPageLoad.cta_list = data.isConfirm ? [] : [data.ContactStoreLabel.ContactStoreSubmit];
      // preQualPageLoad.login_status = UDOConstant.UnityFlag;
      // preQualPageLoad.an_user_id = UDOConstant.preQualPageGroup;
      preQualPageLoad.page_view = '1';
      preQualPageLoad.page_version = '1';
      (window as any).utag_data = preQualPageLoad;
      this.tealium.view((window as any).utag_data);      
    } catch (error) {
      console.log(error);
    }
  }

  getInventoryStatusString(status:string) {
    const s = (status || '').toUpperCase();
    if (s === "S") {
        return "in stock";
    }
    else if (s === "T") {
        return "in transit";
    }
    else if (s === "ANR") {
        return "on hold";
    }
    else return s;
}
  reportClickEventForPrequalConfirmation(data: IConfirmationClickEvent) {
    try {
      this.category_l1 = CategoryL1.Finance;
      this.category_l2 = CategoryL2.PreQual;
      this.category_l3 = data.isVinAvailable ? UDO.VIN : UDO.NO_VIN;
      this.category_l4 = CategoryL4.Confirmation;
      const confirmationPageClickUtag: any = {};
      confirmationPageClickUtag.category_l1 = this.category_l1;
      confirmationPageClickUtag.category_l2 = this.category_l2;
      confirmationPageClickUtag.category_l3 = this.category_l3;
      confirmationPageClickUtag.category_l4 = this.category_l4;
      confirmationPageClickUtag.event = data.isPhoneClicked ? EditEvent.CallButton : EditEvent.MapClick;
      confirmationPageClickUtag.event_category = EventCategory.EngagementType;
      confirmationPageClickUtag.event_action = data.isPhoneClicked ? EventAction.EngagementTypePrequalPhone : EventAction.EngagementType;
      confirmationPageClickUtag.event_label = data.isPhoneClicked ? data.phone : EventLabel.MapClick;
      confirmationPageClickUtag.event_value = UDOConstant.UnityFlag;
      confirmationPageClickUtag.pagegroup = UDOConstant.preQualPageGroup;
      // tslint:disable-next-line: no-unused-expression
      data.isPhoneClicked ? confirmationPageClickUtag.phone_click = UDOConstant.UnityFlag : null;
      (window as any).utag_data = confirmationPageClickUtag;
      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  setCategoryL1() {

    this.category_l1 = CategoryL1.Finance;
  }

  setCategoryL2() {
    this.category_l2 = CategoryL2.Application;
  }

  setCategoryL4() {
    this.category_l4 = CategoryL4.Primary;
  }

  setCategoryL3L4AndFormActualName(action: Actions) {
    switch (action.payload.componentName) {
      case ComponentName.PersonalInfoComponent:
        this.category_l3 = this.isBuyNow ? CategoryL3.BuyNowPersonal : CategoryL3.Personal;
        this.category_l4 = this.isBuyNow ? UDO.NotSet : CategoryL4.Primary;
        this.form_actual_name = this.isBuyNow ? FormAndProcessActualName.FinancePersonal : FormActualName.CreditAppPersonal;
        this.process_actual_name = FormAndProcessActualName.FinancePersonal;
        this.reportFormLoadPageN(FormNumber.PersonalInfo);
        break;

      case ComponentName.ResidenceInfoComponent:
        this.category_l3 = this.isBuyNow ? CategoryL3.BuyNowResidence : CategoryL3.Residence;
        this.category_l4 = this.isBuyNow ? UDO.NotSet : CategoryL4.Primary;
        this.form_actual_name = this.isBuyNow ? FormAndProcessActualName.FinanceResidence : FormActualName.CreditAppResidence;
        this.process_actual_name = FormAndProcessActualName.FinanceResidence;
        this.reportFormLoadPageN(FormNumber.ResidenceInfo);
        break;

      case ComponentName.PreviousResidenceInfoComponent:
        this.category_l3 = this.isBuyNow ? CategoryL3.BuyNowResidence2 : CategoryL3.Residence2;
        this.category_l4 = this.isBuyNow ? UDO.NotSet : CategoryL4.Primary;
        this.form_actual_name = this.isBuyNow ? FormAndProcessActualName.FinanceResidence2 : FormActualName.CreditAppResidence2;
        this.process_actual_name = FormAndProcessActualName.FinanceResidence2;
        this.reportFormLoadPageN(FormNumber.PreviousResidenceInfo);
        break;

      case ComponentName.EmploymentInfoComponent:
        this.category_l3 = this.isBuyNow ? CategoryL3.BuyNowEmployment : CategoryL3.Employment;
        this.category_l4 = this.isBuyNow ? UDO.NotSet : CategoryL4.Primary;
        this.form_actual_name = this.isBuyNow ? FormAndProcessActualName.FinanceEmployment : FormActualName.CreditAppEmployment;
        this.process_actual_name = FormAndProcessActualName.FinanceEmployment;
        this.reportFormLoadPageN(FormNumber.EmploymentInfo);
        break;

      case ComponentName.PreviousEmploymentInfoComponent:
        this.category_l3 = this.isBuyNow ? CategoryL3.BuyNowEmployment2 : CategoryL3.Employment2;
        this.category_l4 = this.isBuyNow ? UDO.NotSet : CategoryL4.Primary;
        this.form_actual_name = this.isBuyNow ? FormAndProcessActualName.FinanceEmployment2 : FormActualName.CreditAppEmployment2;
        this.process_actual_name = FormAndProcessActualName.FinanceEmployment2;
        this.reportFormLoadPageN(FormNumber.EmploymentInfo);
        break;

      case ComponentName.AdditionalInfoComponent:
        this.category_l3 = this.isBuyNow ? CategoryL3.AdditionalIncome : CategoryL3.AdditionalIncome;
        this.category_l4 = this.isBuyNow ? UDO.NotSet : CategoryL4.Primary;
        this.form_actual_name = this.isBuyNow ? FormAndProcessActualName.AdditionIncome : FormActualName.CreditAppAdditionalIncome;
        this.process_actual_name = FormAndProcessActualName.AdditionIncome;
        this.reportFormLoadPageN(FormNumber.AdditionalInfo);
        break;

      case ComponentName.CoBuyerPersonalInfoComponent:
        this.category_l3 = this.isBuyNow ? CategoryL3.BuyNowPersonal : CategoryL3.Personal;
        this.category_l4 = this.isBuyNow && this.coBuyer ? 'Cobuyer' : CategoryL4.Primary;
        this.form_actual_name = this.isBuyNow ? FormAndProcessActualName.FinanceCobuyerPersonal : FormActualName.CreditAppPersonalCobuyer;
        this.process_actual_name = FormAndProcessActualName.FinanceCobuyerPersonal;
        this.reportFormLoadPageN(FormNumber.CoBuyerPersonalInfo);
        break;

      case ComponentName.CoBuyerResidenceInfoComponent:
        this.category_l3 = this.isBuyNow ? CategoryL3.BuyNowResidence : CategoryL3.Residence;
        this.category_l4 = CategoryL4.Cobuyer;
        this.form_actual_name = this.isBuyNow ? FormAndProcessActualName.FinanceCobuyerResidence : FormActualName.CreditAppResidenceCobuyer;
        this.process_actual_name = FormAndProcessActualName.FinanceCobuyerResidence;
        this.reportFormLoadPageN(FormNumber.CoBuyerResidenceInfo);
        break;

      case ComponentName.CoBuyerPreviousResidenceInfoComponent:
        this.category_l3 = this.isBuyNow ? CategoryL3.BuyNowResidence2 : CategoryL3.Residence2;
        this.category_l4 = CategoryL4.Cobuyer;
        // tslint:disable-next-line: max-line-length
        this.form_actual_name = this.isBuyNow ? FormAndProcessActualName.FinanceCobuyerResidence2 : FormActualName.CreditAppResidenceCobuyer2;
        this.process_actual_name = FormAndProcessActualName.FinanceCobuyerResidence2;
        this.reportFormLoadPageN(FormNumber.CoBuyerPreviousResidenceInfo);
        break;

      case ComponentName.CoBuyerEmploymentInfoComponent:
        this.category_l3 = this.isBuyNow ? CategoryL3.BuyNowEmployment : CategoryL3.Employment;
        this.category_l4 = CategoryL4.Cobuyer;
        // tslint:disable-next-line: max-line-length
        this.form_actual_name = this.isBuyNow ? FormAndProcessActualName.FinanceCobuyerEmployment : FormActualName.CreditAppEmploymentCobuyer;
        this.process_actual_name = FormAndProcessActualName.FinanceCobuyerEmployment;
        this.reportFormLoadPageN(FormNumber.CoBuyerEmploymentInfo);
        break;

      case ComponentName.CoBuyerPreviousEmploymentInfoComponent:
        this.category_l3 = this.isBuyNow ? CategoryL3.BuyNowEmployment2 : CategoryL3.Employment2;
        this.category_l4 = CategoryL4.Cobuyer;
        // tslint:disable-next-line: max-line-length
        this.form_actual_name = this.isBuyNow ? FormAndProcessActualName.FinanceCobuyerEmployment2 : FormActualName.CreditAppEmploymentCobuyer2;
        this.process_actual_name = FormAndProcessActualName.FinanceCobuyerEmployment2;
        this.reportFormLoadPageN(FormNumber.CoBuyerPreviousEmploymentInfo);
        break;

      case ComponentName.CoBuyerAdditionalInfoComponent:
        this.category_l3 = this.isBuyNow ? CategoryL3.BuyNowAdditionalIncome : CategoryL3.AdditionalIncome;
        this.category_l4 = CategoryL4.Cobuyer;
        // tslint:disable-next-line: max-line-length
        this.form_actual_name = this.isBuyNow ? FormAndProcessActualName.AdditionCobuyerIncome : FormActualName.CreditAppAdditionalIncomeCobuyer;
        this.process_actual_name = FormAndProcessActualName.AdditionCobuyerIncome;
        this.reportFormLoadPageN(FormNumber.CoBuyerAdditionalInfo);
        break;

      case ComponentName.ReviewInfoComponent:
        this.category_l3 = CategoryL3.Review;
        this.category_l4 = this.coBuyer ? 'Cobuyer' : UDO.NotSet;
        this.form_actual_name = this.isBuyNow ? FormAndProcessActualName.FinanceReview : FormActualName.CreditAppReview;
        this.process_actual_name = FormAndProcessActualName.FinanceReview;
        this.reportFormLoadPageN(FormNumber.ReviewInfo);
        break;

      case ComponentName.ConfirmationPageComponent:
        this.category_l3 = CategoryL3.Confirmation;
        this.category_l4 = UDO.NotSet;
        this.form_actual_name = FormActualName.CreditAppConfirm;
        break;
    }
  }

  setPageSubmit(action: Actions) {
    switch (action.payload.componentName) {
      case ComponentName.PersonalInfoComponent:
        this.reportFormPageNSubmit();
        break;

      case ComponentName.ResidenceInfoComponent:
        this.reportFormPageNSubmit();
        break;

      case ComponentName.PreviousResidenceInfoComponent:
        this.reportFormPageNSubmit();
        break;

      case ComponentName.EmploymentInfoComponent:
        this.reportFormPageNSubmit();
        break;

      case ComponentName.PreviousEmploymentInfoComponent:
        this.reportFormPageNSubmit();
        break;

      case ComponentName.AdditionalInfoComponent:
        this.reportFormPageNSubmit();
        break;

      case ComponentName.CoBuyerPersonalInfoComponent:
        this.reportFormPageNSubmit();
        break;

      case ComponentName.CoBuyerResidenceInfoComponent:
        this.reportFormPageNSubmit();
        break;

      case ComponentName.CoBuyerPreviousResidenceInfoComponent:
        this.reportFormPageNSubmit();
        break;

      case ComponentName.CoBuyerEmploymentInfoComponent:
        this.reportFormPageNSubmit();
        break;

      case ComponentName.CoBuyerPreviousEmploymentInfoComponent:
        this.reportFormPageNSubmit();
        break;

      case ComponentName.CoBuyerAdditionalInfoComponent:
        this.reportFormPageNSubmit();
        break;

      case ComponentName.ReviewInfoComponent:
        this.reportFormPageNSubmit();
        break;
    }
  }



  reportSubmitApplication() {
    try {
      const caSubmitApplicationUtag: any = {};
      caSubmitApplicationUtag.category_l1 = this.category_l1;
      caSubmitApplicationUtag.category_l2 = this.category_l2;
      caSubmitApplicationUtag.category_l3 = this.category_l3;
      caSubmitApplicationUtag.category_l4 = this.category_l4;
      caSubmitApplicationUtag.event = EditEvent.SubmitApplication;
      caSubmitApplicationUtag.event_value = UDOConstant.UnityFlag;
      caSubmitApplicationUtag.event_category = EventCategory.EngagementType;
      caSubmitApplicationUtag.event_action = EventAction.EngagementType;
      caSubmitApplicationUtag.event_label = EventLabel.SubmitApplication;

      (window as any).utag_data = caSubmitApplicationUtag;

      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  reportUnlockCreditApp() {
    try {
      const caUnlockCreditAppUtag: any = {};
      caUnlockCreditAppUtag.category_l1 = this.category_l1;
      caUnlockCreditAppUtag.category_l2 = this.category_l2;
      caUnlockCreditAppUtag.category_l3 = CategoryL3.Unlock;
      caUnlockCreditAppUtag.category_l4 = UDO.NotSet;
      caUnlockCreditAppUtag.event = EditEvent.UnlockCreditApp;
      caUnlockCreditAppUtag.event_value = UDOConstant.UnityFlag;
      caUnlockCreditAppUtag.event_category = EventCategory.EngagementType;
      caUnlockCreditAppUtag.event_action = EventAction.EngagementType;
      caUnlockCreditAppUtag.event_label = EventLabel.UnlockCreditApp;

      (window as any).utag_data = caUnlockCreditAppUtag;

      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  reportNewCreditApp() {
    try {
      const caNewCreditAppUtag: any = {};
      caNewCreditAppUtag.category_l1 = this.category_l1;
      caNewCreditAppUtag.category_l2 = this.category_l2;
      caNewCreditAppUtag.category_l3 = CategoryL3.CreditApplicationsModal;
      caNewCreditAppUtag.category_l4 = UDO.NotSet;
      caNewCreditAppUtag.event = EditEvent.CreateNewCreditApp;
      caNewCreditAppUtag.event_value = UDOConstant.UnityFlag;
      caNewCreditAppUtag.event_category = EventCategory.EngagementType;
      caNewCreditAppUtag.event_action = EventAction.EngagementType;
      caNewCreditAppUtag.event_label = EventLabel.CreateNewCreditApp;

      (window as any).utag_data = caNewCreditAppUtag;

      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  reportEditCTAClick(action: Actions) {
    try {
      const caEditClickedUtag: any = {};
      caEditClickedUtag.category_l1 = this.category_l1;
      caEditClickedUtag.category_l2 = this.category_l2;
      caEditClickedUtag.category_l3 = this.category_l3;
      caEditClickedUtag.category_l4 = this.category_l4;

      switch (action.payload.componentName) {
        case ComponentName.PersonalInfoComponent:
          caEditClickedUtag.event = EditEvent.EditPersonalInfo;
          caEditClickedUtag.event_value = UDOConstant.UnityFlag;
          caEditClickedUtag.event_category = EventCategory.EngagementType;
          caEditClickedUtag.event_action = EventAction.EngagementType;
          caEditClickedUtag.event_label = EventLabel.EditPersonalInfo;
          break;

        case ComponentName.ResidenceInfoComponent:
          caEditClickedUtag.event = EditEvent.EditResidenceInfo;
          caEditClickedUtag.event_value = UDOConstant.UnityFlag;
          caEditClickedUtag.event_category = EventCategory.EngagementType;
          caEditClickedUtag.event_action = EventAction.EngagementType;
          caEditClickedUtag.event_label = EventLabel.EditResidenceInfo;
          break;

        case ComponentName.EmploymentInfoComponent:
          caEditClickedUtag.event = EditEvent.EditEmploymentInfo;
          caEditClickedUtag.event_value = UDOConstant.UnityFlag;
          caEditClickedUtag.event_category = EventCategory.EngagementType;
          caEditClickedUtag.event_action = EventAction.EngagementType;
          caEditClickedUtag.event_label = EventLabel.EditEmploymentInfo;
          break;

        case ComponentName.AdditionalInfoComponent:
          caEditClickedUtag.event = EditEvent.EditAdditionalInfo;
          caEditClickedUtag.event_value = UDOConstant.UnityFlag;
          caEditClickedUtag.event_category = EventCategory.EngagementType;
          caEditClickedUtag.event_action = EventAction.EngagementType;
          caEditClickedUtag.event_label = EventLabel.EditAdditionalInfo;
          break;

        case ComponentName.CoBuyerPersonalInfoComponent:
          caEditClickedUtag.event = EditEvent.EditCobuyerPersonalInfo;
          caEditClickedUtag.event_value = UDOConstant.UnityFlag;
          caEditClickedUtag.event_category = EventCategory.EngagementType;
          caEditClickedUtag.event_action = EventAction.EngagementType;
          caEditClickedUtag.event_label = EventLabel.EditCobuyerPersonalInfo;
          break;

        case ComponentName.CoBuyerResidenceInfoComponent:
          caEditClickedUtag.event = EditEvent.EditCobuyerResidenceInfo;
          caEditClickedUtag.event_value = UDOConstant.UnityFlag;
          caEditClickedUtag.event_category = EventCategory.EngagementType;
          caEditClickedUtag.event_action = EventAction.EngagementType;
          caEditClickedUtag.event_label = EventLabel.EditCobuyerResidenceInfo;
          break;

        case ComponentName.CoBuyerEmploymentInfoComponent:
          caEditClickedUtag.event = EditEvent.EditCobuyerEmploymentInfo;
          caEditClickedUtag.event_value = UDOConstant.UnityFlag;
          caEditClickedUtag.event_category = EventCategory.EngagementType;
          caEditClickedUtag.event_action = EventAction.EngagementType;
          caEditClickedUtag.event_label = EventLabel.EditCobuyerEmploymentInfo;
          break;

        case ComponentName.CoBuyerAdditionalInfoComponent:
          caEditClickedUtag.event = EditEvent.EditCobuyerAdditionalInfo;
          caEditClickedUtag.event_value = UDOConstant.UnityFlag;
          caEditClickedUtag.event_category = EventCategory.EngagementType;
          caEditClickedUtag.event_action = EventAction.EngagementType;
          caEditClickedUtag.event_label = EventLabel.EditCobuyerAdditionalInfo;
          break;
      }

      (window as any).utag_data = caEditClickedUtag;

      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  reportFormLoadPageN(pageNumber: number) {
    try {
      const caFormLoadPageNUtag: any = {};
      caFormLoadPageNUtag.category_l1 = this.category_l1;
      caFormLoadPageNUtag.category_l2 = this.category_l2;
      caFormLoadPageNUtag.category_l3 = this.category_l3;
      caFormLoadPageNUtag.category_l4 = this.category_l4;
      caFormLoadPageNUtag.form_actual_name = this.form_actual_name;
      caFormLoadPageNUtag.form_page_load = UDOConstant.UnityFlag;


      if (this.isBuyNow) {

        if (this.process_actual_name === FormAndProcessActualName.FinancePersonal) {
          caFormLoadPageNUtag.event = EditEvent.FormLoad;
          caFormLoadPageNUtag.event_category = EventCategory.LeadSubmission;
          caFormLoadPageNUtag.event_action = EventAction.LeadSubmissionDigitalRetailingFormLoad;
          caFormLoadPageNUtag.event_label = EventLabel.FinanceApplicationFormLoad;
          caFormLoadPageNUtag.event_value = 1;

          this.dynamicYieldService.track(DynamicYieldEventName.FormLoadCreditApplication, {
            form_actual_name: this.form_actual_name,
            form_name: 'finance'
          });
        }

        caFormLoadPageNUtag.form_name = 'finance';
        caFormLoadPageNUtag.process_name = UDOConstant.DigitalRetailing;
        caFormLoadPageNUtag.pagegroup = UDOConstant.FinanceApplicationPageGroup;
        caFormLoadPageNUtag.process_actual_name = this.process_actual_name;
        caFormLoadPageNUtag.form_actual_name = this.form_actual_name;
        if (pageNumber === 1) {
          const tealiumVehicleInfo: any = (window as any).buynow.Tealium.vehicleInfo || {};
          caFormLoadPageNUtag.enh_action = UDOConstant.Checkout;
          caFormLoadPageNUtag.enh_vehic_brand = tealiumVehicleInfo.enh_vehic_brand || '';
          caFormLoadPageNUtag.enh_vehic_id = tealiumVehicleInfo.enh_vehic_id || '';
          caFormLoadPageNUtag.enh_vehic_name = tealiumVehicleInfo.enh_vehic_name || '';
          caFormLoadPageNUtag.enh_vehic_price = tealiumVehicleInfo.enh_vehic_price || '';
          caFormLoadPageNUtag.enh_vehic_variant = tealiumVehicleInfo.enh_vehic_variant || '';
          caFormLoadPageNUtag.enh_checkout_step = 6;
          caFormLoadPageNUtag.enh_vehic_category = tealiumVehicleInfo.enh_vehic_category || '';
          caFormLoadPageNUtag.enh_vehic_discount = Math.abs(Number(tealiumVehicleInfo.enh_vehic_discount.unlockedDiscount)) || 0;
          caFormLoadPageNUtag.non_interaction = true;
        }


      } else {
        caFormLoadPageNUtag['process_step' + pageNumber] = UDOConstant.UnityFlag;
        caFormLoadPageNUtag.process_actual_name = this.process_actual_name;
        caFormLoadPageNUtag.process_name = this.process_name;
        if (pageNumber === 1) {
          caFormLoadPageNUtag.event_category = EventCategory.LeadSubmission;
          caFormLoadPageNUtag.event_action = EventAction.LeadSubmission;
          caFormLoadPageNUtag.event_label = EventLabel.CreditApplicationFormLoad;
        }
      }

      (window as any).utag_data = caFormLoadPageNUtag;
      this.tealium.view((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  reportFormPageNSubmit() {
    try {
      const caFormPageNSubmitUtag: any = {};

      caFormPageNSubmitUtag.category_l1 = this.category_l1;
      caFormPageNSubmitUtag.category_l2 = this.category_l2;
      caFormPageNSubmitUtag.category_l3 = this.category_l3;
      caFormPageNSubmitUtag.category_l4 = this.category_l4;
      caFormPageNSubmitUtag.form_actual_name = this.form_actual_name;
      caFormPageNSubmitUtag.form_page_submit = UDOConstant.UnityFlag;

      (window as any).utag_data = caFormPageNSubmitUtag;

      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  reportSubmitInitiated() {
    try {
      const caFormSubmitInitiatedUtag: any = {};
      caFormSubmitInitiatedUtag.category_l1 = this.category_l1;
      caFormSubmitInitiatedUtag.category_l2 = this.category_l2;
      caFormSubmitInitiatedUtag.category_l3 = this.category_l3;
      caFormSubmitInitiatedUtag.category_l4 = this.coBuyer && this.isBuyNow ? 'Cobuyer' : this.category_l4;
      caFormSubmitInitiatedUtag.form_actual_name = this.form_actual_name;
      caFormSubmitInitiatedUtag.event_category = EventCategory.LeadSubmission;
      caFormSubmitInitiatedUtag.event_action = EventAction.LeadSubmission;
      caFormSubmitInitiatedUtag.event_label = EventLabel.CreditApplicationSubmitInitiated;
      caFormSubmitInitiatedUtag.submit_initiated = UDOConstant.UnityFlag;
      if (this.isBuyNow) {
        caFormSubmitInitiatedUtag.event = EditEvent.FormSubmitInitiated;
        caFormSubmitInitiatedUtag.event_category = EventCategory.LeadSubmission;
        caFormSubmitInitiatedUtag.event_action = EventAction.LeadSubmissionDigitalRetailingSubmitInitiated;
        caFormSubmitInitiatedUtag.event_label = EventLabel.FinanceApplicationSubmitInitiated;
        caFormSubmitInitiatedUtag.event_value = 1;
        caFormSubmitInitiatedUtag.form_name = 'finance';
        caFormSubmitInitiatedUtag.process_name = UDOConstant.DigitalRetailing;
        caFormSubmitInitiatedUtag.pagegroup = UDOConstant.FinanceApplicationPageGroup;
        caFormSubmitInitiatedUtag.process_actual_name = this.process_actual_name;
      }
      (window as any).utag_data = caFormSubmitInitiatedUtag;

      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  reportFormStarted() {
    try {
      const caFormStartedUtag: any = {};
      caFormStartedUtag.category_l1 = this.category_l1;
      caFormStartedUtag.category_l2 = this.category_l2;
      caFormStartedUtag.category_l3 = this.category_l3;
      caFormStartedUtag.category_l4 = this.category_l4;
      caFormStartedUtag.form_actual_name = this.form_actual_name;
      caFormStartedUtag.form_started = UDOConstant.UnityFlag;
      caFormStartedUtag.event_category = EventCategory.LeadSubmission;
      caFormStartedUtag.event_action = EventAction.LeadSubmission;
      caFormStartedUtag.event_label = EventLabel.CreditApplicationFormStarted;
      if (this.isBuyNow) {
        caFormStartedUtag.event = EditEvent.FormStarted;
        caFormStartedUtag.event_category = EventCategory.LeadSubmission;
        caFormStartedUtag.event_action = EventAction.LeadSubmissionDigitalRetailingFormStarted;
        caFormStartedUtag.event_label = EventLabel.FinanceApplicationFormStarted;
        caFormStartedUtag.event_value = 1;
        caFormStartedUtag.form_name = 'finance';
        caFormStartedUtag.process_name = UDOConstant.DigitalRetailing;
        caFormStartedUtag.pagegroup = UDOConstant.FinanceApplicationPageGroup;
        caFormStartedUtag.process_actual_name = this.process_actual_name;
      }
      (window as any).utag_data = caFormStartedUtag;

      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  reportSubmitStatus(status: boolean) {
    try {
      const caReportSubmitStatus: any = {};
      caReportSubmitStatus.category_l1 = this.category_l1;
      caReportSubmitStatus.category_l2 = this.category_l2;
      caReportSubmitStatus.category_l3 = this.category_l3;
      caReportSubmitStatus.category_l4 = this.category_l4;
      caReportSubmitStatus.form_actual_name = this.form_actual_name;
      caReportSubmitStatus.event_category = EventCategory.LeadSubmission;
      caReportSubmitStatus.event_action = EventAction.LeadSubmission;

      if (status) {
        caReportSubmitStatus.form_success = UDOConstant.UnityFlag;
        caReportSubmitStatus.event_label = EventLabel.CreditApplicationSubmitSuccess;
      } else {
        caReportSubmitStatus.form_failure = UDOConstant.UnityFlag;
        caReportSubmitStatus.event_label = EventLabel.CreditApplicationSubmitFailure;
      }

      if (this.isBuyNow) {
        caReportSubmitStatus.event = status ? EditEvent.FormSuccess : EditEvent.FormFailure;
        caReportSubmitStatus.event_category = EventCategory.LeadSubmission;
        // tslint:disable-next-line: max-line-length
        caReportSubmitStatus.event_action = status ? EventAction.LeadSubmissionDigitalRetailingFormSuccess : EventAction.LeadSubmissionDigitalRetailingFormFailure;
        caReportSubmitStatus.event_label = status ? EventLabel.FinanceApplicationFormSuccess : EventLabel.FinanceApplicationFormFailure;
        caReportSubmitStatus.event_value = 1;
        caReportSubmitStatus.form_name = 'finance';
        caReportSubmitStatus.process_name = UDOConstant.DigitalRetailing;
        caReportSubmitStatus.pagegroup = UDOConstant.FinanceApplicationPageGroup;
        caReportSubmitStatus.form_actual_name = FormAndProcessActualName.FinanceReview;
        caReportSubmitStatus.process_actual_name = FormAndProcessActualName.FinanceReview;

        if (status) {
          this.dynamicYieldService.track(DynamicYieldEventName.FormSuccessCreditApplication, {
            form_actual_name: caReportSubmitStatus.form_actual_name,
            form_name: 'finance',
            lead_provider_id: '5522'
          });
        }

      }
      (window as any).utag_data = caReportSubmitStatus;

      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

   reportValidationFailure(data: string) {
    try {
      const caReportSubmitStatus: any = {};
      caReportSubmitStatus.category_l1 = this.category_l1;
      caReportSubmitStatus.category_l2 = this.category_l2;
      caReportSubmitStatus.category_l3 = this.category_l3;
      caReportSubmitStatus.category_l4 = data;
      caReportSubmitStatus.form_name = this.form_actual_name;
      caReportSubmitStatus.form_actual_name = this.form_actual_name;
      caReportSubmitStatus.form_failure = '0';
      caReportSubmitStatus.event_value = 1;
      caReportSubmitStatus.event_type = UDO.NotSet;
      caReportSubmitStatus.event_action = EventAction.LeadSubmission;
      caReportSubmitStatus.event_category = EventCategory.LeadSubmission;
      caReportSubmitStatus.event_name = UDO.NotSet;
      caReportSubmitStatus.event = 'form_failure_validation';
      caReportSubmitStatus.event_label = EventLabel.CreditApplicationSubmitFailure;
      caReportSubmitStatus.event_page_location = UDO.NotSet;
      caReportSubmitStatus.pagegroup = UDO.NotSet;
      caReportSubmitStatus.page_referral = UDO.NotSet;

      if (this.isBuyNow) {
        caReportSubmitStatus.event_category = EventCategory.LeadSubmission;
        // tslint:disable-next-line: max-line-length
        caReportSubmitStatus.event_action = EventAction.LeadSubmissionDigitalRetailingFormFailure;
        caReportSubmitStatus.event_label = EventLabel.FinanceApplicationFormFailure;
        caReportSubmitStatus.form_name = 'finance';
        caReportSubmitStatus.pagegroup = UDOConstant.FinanceApplicationPageGroup;
        caReportSubmitStatus.form_actual_name = FormAndProcessActualName.FinanceReview;
      }
      (window as any).utag_data = caReportSubmitStatus;
      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  reportValidationPrequalFailure(data: string, isVinAvailable : boolean) {
    try {
      this.category_l1 = CategoryL1.Finance;
      this.category_l2 = CategoryL2.PreQual;
      this.category_l3 = isVinAvailable ? UDO.VIN : UDO.NO_VIN;
      const preQualFormEvent: any = {};
      preQualFormEvent.category_l1 = this.category_l1;
      preQualFormEvent.category_l2 = this.category_l2;
      preQualFormEvent.category_l3 = this.category_l3;
      preQualFormEvent.category_l4 = data;
      preQualFormEvent.form_name = FormName.PreQualForm;
      preQualFormEvent.form_actual_name = FormActualName.PreQualForm;
      preQualFormEvent.event = 'form_failure_validation';
      preQualFormEvent.form_failure = '0';
      preQualFormEvent.event_type = UDO.NotSet;
      preQualFormEvent.event_name = UDO.NotSet;
      preQualFormEvent.event_value = UDOConstant.UnityFlag;
      preQualFormEvent.event_category = EventCategory.LeadSubmission;
      preQualFormEvent.event_action = EventAction.EngagementTypePrequalLeadFailure;
      preQualFormEvent.event_label = EventLabel.PreQualFormFailure;
      preQualFormEvent.pagegroup = UDOConstant.preQualPageGroup;
      preQualFormEvent.event_page_location = UDO.NotSet;
      preQualFormEvent.page_referral = UDO.NotSet;
      if(this.config?.Sitecore?.isBuyNow) {
        preQualFormEvent.category_l1 = "Online Buying";
        preQualFormEvent.category_l2 = "Personal Details";
        preQualFormEvent.category_l3 = UDO.NotSet;
        preQualFormEvent.form_name = "personal_details";
        preQualFormEvent.form_actual_name = "personal-details";
        preQualFormEvent.event_action = "Lead Submission_Digital Retailing|||Form_Failure";
        preQualFormEvent.event_label = "Personal Details-Form Failure";
      }
      (window as any).utag_data = preQualFormEvent;
      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  reportLeadFormData(ca: CreditApplication) {
    try {
      this.category_l2 = CategoryL2.Application;
      const caLeadFormSubmissionUtag: any = {};

      caLeadFormSubmissionUtag.category_l1 = this.category_l1;
      caLeadFormSubmissionUtag.category_l2 = this.category_l2;
      caLeadFormSubmissionUtag.category_l3 = UDO.NotSet;
      caLeadFormSubmissionUtag.category_l4 = UDO.NotSet;
      caLeadFormSubmissionUtag.form_name = 'finance';
      caLeadFormSubmissionUtag.form_actual_name = 'credit-app-step-2';
      caLeadFormSubmissionUtag.lead_submission = '1';
      caLeadFormSubmissionUtag.lead_cust_zip = ca?.buyer?.personalInformation?.currentAddress?.postalCode;
      caLeadFormSubmissionUtag.lead_vin = ca.shortForm.vehicleInformation.vin ?
      ca.shortForm.vehicleInformation.vin : UDO.NotSet;
      caLeadFormSubmissionUtag.lead_inv_type = ca.shortForm.vehicleInformation.stockType ?
      ca.shortForm.vehicleInformation.stockType : UDO.NotSet; 
      caLeadFormSubmissionUtag.lead_make = ca.shortForm.vehicleInformation.make ?
      ca.shortForm.vehicleInformation.make : UDO.NotSet;
      caLeadFormSubmissionUtag.lead_make_yr = ca.shortForm.vehicleInformation.year ?
      ca.shortForm.vehicleInformation.year : UDO.NotSet;
      caLeadFormSubmissionUtag.lead_make_model = ca.shortForm.vehicleInformation.model ?
      ca.shortForm.vehicleInformation.model : UDO.NotSet;
      caLeadFormSubmissionUtag.lead_hyperion = ca.shortForm.vehicleInformation.hyperionId ?
      ca.shortForm.vehicleInformation.hyperionId : UDO.NotSet; 
      this.creditAppService.StoreDetails$.subscribe(res => {
        console.log('subscribed to response', res);
        if(res){
          caLeadFormSubmissionUtag.lead_store_name = res? res : UDO.NotSet; 
        }
      })
      caLeadFormSubmissionUtag.lead_provider_id = '5522';
      caLeadFormSubmissionUtag.lead_voi = ca.shortForm.vehicleInformation.make ?
      UDOConstant.UnityFlag : UDO.NotSet;
      caLeadFormSubmissionUtag.cobuyer_added = ca.coBuyer ?
        UDOConstant.UnityFlag : UDO.NotSet;

      (window as any).utag_data = caLeadFormSubmissionUtag;

      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  reportServerError(errorData: IAnalyticsErrorResponse) {
    try {
      const caFormServerErrorUtag: any = {};
      caFormServerErrorUtag.category_l1 = this.category_l1;
      caFormServerErrorUtag.category_l2 = this.category_l2;
      caFormServerErrorUtag.category_l3 = this.category_l3;
      caFormServerErrorUtag.category_l4 = this.category_l4;
      caFormServerErrorUtag.error = errorData.error ? errorData.error : UDOConstant.ErrorCode;
      caFormServerErrorUtag.error_message = errorData.error_message ? errorData.error_message : UDOConstant.ServiceUnavailable;
      caFormServerErrorUtag.error_type = errorData.error_type ? errorData.error_type : ErrorType.GeneralError;

      (window as any).utag_data = caFormServerErrorUtag;

      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  reportContactStoreFormLoaded(data) {
    try {
      this.category_l1 = CategoryL1.Contact;
      this.category_l2 = CategoryL2.OEM;
      this.category_l3 = UDO.NotSet;
      this.category_l4 = UDO.NotSet;
      const leadFormData: any = {};
      leadFormData.category_l1 = this.category_l1;
      leadFormData.category_l2 = this.category_l2;
      leadFormData.category_l3 = this.category_l3;
      leadFormData.category_l4 = this.category_l4;
      leadFormData.form_name = FormName.OEMReferral;
      leadFormData.form_actual_name = FormActualName.OEMContact;
      leadFormData.form_page_load	= 1;
      leadFormData.form_load_page1 = 1;
      leadFormData.event_value = 1;
      leadFormData.event_type	= "InternalActivity";
      leadFormData.event_action	= "form";
      leadFormData.event_category	= "contact";
      leadFormData.event_name	= "page_engagement";
      leadFormData.event = "form_load";
      leadFormData.event_label	= "Contact-Form Load";
      leadFormData.event_description	= "form_load";
      leadFormData.event_page_location = UDO.NotSet;
      leadFormData.pagegroup	= "contact";
      leadFormData.page_element	= "form";
      // leadFormData.page_referral = 
      leadFormData.vin= data.leftRailVehicleData.Vin;
      leadFormData.hyperion_id = data.Hid;
      leadFormData.make = data.leftRailVehicleData.Make;
      leadFormData.make_yr = data.leftRailVehicleData.Year;
      leadFormData.model = data.leftRailVehicleData.Model;
      leadFormData.condition = data.leftRailVehicleData.InventoryVehicleDetail.StockType;
      // leadFormData.login_status = 
      // leadFormData.an_user_id =

      (window as any).utag_data = leadFormData;
      this.tealium.link((window as any).utag_data);      
    } catch (error) {
      console.log(error);
    }
  }

  reportContactStoreFormStarted(data) {
    try {
      this.category_l1 = CategoryL1.Contact;
      this.category_l2 = CategoryL2.OEM;
      this.category_l3 = UDO.NotSet;
      this.category_l4 = UDO.NotSet;
      const leadFormData: any = {};
      leadFormData.category_l1 = this.category_l1;
      leadFormData.category_l2 = this.category_l2;
      leadFormData.category_l3 = this.category_l3;
      leadFormData.category_l4 = this.category_l4;
      leadFormData.form_name = FormName.OEMReferral;
      leadFormData.form_actual_name = FormActualName.OEMContact;
      leadFormData.form_started	= 1;
      leadFormData.event_value = 1;
      leadFormData.event_type	= "InternalActivity";
      leadFormData.event_action	= "form";
      leadFormData.event_category	= "contact";
      leadFormData.event_name	= "page_engagement";
      leadFormData.event = "form_started";
      leadFormData.event_label	= "Contact-Form Started";
      leadFormData.event_description	= "form_started";
      leadFormData.event_page_location = UDO.NotSet;
      leadFormData.pagegroup	= "contact";
      leadFormData.page_element	= "form";
      // leadFormData.page_referral = 
      leadFormData.vin= data.leftRailVehicleData.Vin;
      leadFormData.hyperion_id = data.Hid;
      leadFormData.make = data.leftRailVehicleData.Make;
      leadFormData.make_yr = data.leftRailVehicleData.Year;
      leadFormData.model = data.leftRailVehicleData.Model;
      leadFormData.condition = data.leftRailVehicleData.InventoryVehicleDetail.StockType;
      // leadFormData.login_status = 
      // leadFormData.an_user_id =

      (window as any).utag_data = leadFormData;
      this.tealium.link((window as any).utag_data);      
    } catch (error) {
      console.log(error);
    }
  }

  reportContactStoreFormSubmitInitiated(data) {
    try {
      this.category_l1 = CategoryL1.Contact;
      this.category_l2 = CategoryL2.OEM;
      this.category_l3 = UDO.NotSet;
      this.category_l4 = UDO.NotSet;
      const leadFormData: any = {};
      leadFormData.category_l1 = this.category_l1;
      leadFormData.category_l2 = this.category_l2;
      leadFormData.category_l3 = this.category_l3;
      leadFormData.category_l4 = this.category_l4;
      leadFormData.form_name = FormName.OEMReferral;
      leadFormData.form_actual_name = FormActualName.OEMContact;
      leadFormData.submit_initiated	= 1;
      leadFormData.event_value = 1;
      leadFormData.event_type	= "InternalActivity";
      leadFormData.event_action	= "form";
      leadFormData.event_category	= "contact";
      leadFormData.event_name	= "page_engagement";
      leadFormData.event = "submit_initiated";
      leadFormData.event_label	= "Contact-Submit Initiated";
      leadFormData.event_description	= "submit_initiated";
      leadFormData.event_page_location = UDO.NotSet;
      leadFormData.pagegroup	= "contact";
      leadFormData.page_element	= "form";
      // leadFormData.page_referral = 
      leadFormData.vin= data.leftRailVehicleData.Vin;
      leadFormData.hyperion_id = data.Hid;
      leadFormData.make = data.leftRailVehicleData.Make;
      leadFormData.make_yr = data.leftRailVehicleData.Year;
      leadFormData.model = data.leftRailVehicleData.Model;
      leadFormData.condition = data.leftRailVehicleData.InventoryVehicleDetail.StockType;
      // leadFormData.login_status = 
      // leadFormData.an_user_id =

      (window as any).utag_data = leadFormData;
      this.tealium.link((window as any).utag_data);      
    } catch (error) {
      console.log(error);
    }
  }

  reportContactStoreFormLeadSubmitted(data,response?:any) {
    try {
      this.category_l1 = CategoryL1.Contact;
      this.category_l2 = CategoryL2.OEM;
      this.category_l3 = UDO.NotSet;
      this.category_l4 = UDO.NotSet;
      const leadFormData: any = {};
      leadFormData.category_l1 = this.category_l1;
      leadFormData.category_l2 = this.category_l2;
      leadFormData.category_l3 = this.category_l3;
      leadFormData.category_l4 = this.category_l4;
      leadFormData.form_name = FormName.OEMReferral;
      leadFormData.form_actual_name = FormActualName.OEMContact;
      leadFormData.lead_submission	= 1;
      leadFormData.event_value = 1;
      leadFormData.event_type	= "InternalActivity";
      leadFormData.event_action	= "form";
      leadFormData.event_category	= "contact";
      leadFormData.event_name	= "page_engagement";
      leadFormData.event = "lead_submission";
      leadFormData.event_label	= "Contact-Lead Submission";
      leadFormData.event_description	= "lead_submission";
      leadFormData.event_page_location = UDO.NotSet;
      leadFormData.pagegroup	= "contact";
      leadFormData.page_element	= "form";
      // leadFormData.page_referral = 
      leadFormData.lead_vin= data.leftRailVehicleData.Vin;
      leadFormData.hyperion_id = data.Hid;
      leadFormData.lead_make = data.leftRailVehicleData.Make;
      leadFormData.lead_make_yr = data.leftRailVehicleData.Year;
      leadFormData.lead_make_model = data.leftRailVehicleData.Make + data.leftRailVehicleData.Model;
      leadFormData.condition = data.leftRailVehicleData.InventoryVehicleDetail.StockType;
      // leadFormData.login_status = 
      // leadFormData.an_user_id =
      // leadFormData.hid = 
      leadFormData.lead_appt_date	= UDO.NotSet;
      leadFormData.lead_cust_zip	= data.LeadInfo.zipcode ? data.LeadInfo.zipcode : this.GetCustZipcode();
      leadFormData.lead_hyperion	= data.Hid;
      leadFormData.lead_inv_type	= data.leftRailVehicleData.InventoryVehicleDetail.StockType;
      leadFormData.lead_provider_id	= "AutoNation";
      leadFormData.lead_store_name	= data.StoreInfo.Name
      leadFormData.lead_duplicate = response.isNew  ? '0' : '1';
      (window as any).utag_data = leadFormData;
      this.tealium.link((window as any).utag_data);      
    } catch (error) {
      console.log(error);
    }
  }

  reportContactStoreFormSuccess(data) {
    try {
      this.category_l1 = CategoryL1.Contact;
      this.category_l2 = CategoryL2.OEM;
      this.category_l3 = UDO.NotSet;
      this.category_l4 = UDO.NotSet;
      const leadFormData: any = {};
      leadFormData.category_l1 = this.category_l1;
      leadFormData.category_l2 = this.category_l2;
      leadFormData.category_l3 = this.category_l3;
      leadFormData.category_l4 = this.category_l4;
      leadFormData.form_name = FormName.OEMReferral;
      leadFormData.form_actual_name = FormActualName.OEMContact;
      leadFormData.form_success	= 1;
      leadFormData.event_value = 1;
      leadFormData.event_type	= "InternalActivity";
      leadFormData.event_action	= "form";
      leadFormData.event_category	= "contact";
      leadFormData.event_name	= "page_engagement";
      leadFormData.event = "form_success";
      leadFormData.event_label	= "Contact-Form Success";
      leadFormData.event_description	= "form_success";
      leadFormData.event_page_location = UDO.NotSet;
      leadFormData.pagegroup	= "contact";
      leadFormData.page_element	= "form";
      // leadFormData.page_referral = 
      leadFormData.vin= data.leftRailVehicleData.Vin;
      leadFormData.hyperion_id = data.Hid;
      leadFormData.make = data.leftRailVehicleData.Make;
      leadFormData.make_yr = data.leftRailVehicleData.Year;
      leadFormData.model = data.leftRailVehicleData.Model;
      leadFormData.condition = data.leftRailVehicleData.InventoryVehicleDetail.StockType;
      // leadFormData.login_status = 
      // leadFormData.an_user_id =
      
      (window as any).utag_data = leadFormData;
      this.tealium.link((window as any).utag_data);      
    } catch (error) {
      console.log(error);
    }
  }

  reportContactStoreFormFailure(data) {
    try {
      this.category_l1 = CategoryL1.Contact;
      this.category_l2 = CategoryL2.OEM;
      this.category_l3 = UDO.NotSet;
      this.category_l4 = UDO.NotSet;
      const leadFormData: any = {};
      leadFormData.category_l1 = this.category_l1;
      leadFormData.category_l2 = this.category_l2;
      leadFormData.category_l3 = this.category_l3;
      leadFormData.category_l4 = this.category_l4;
      leadFormData.form_name = FormName.OEMReferral;
      leadFormData.form_actual_name = FormActualName.OEMContact;
      leadFormData.form_failure	= 1;
      leadFormData.event_value = 1;
      leadFormData.event_type	= "InternalActivity";
      leadFormData.event_action	= "form";
      leadFormData.event_category	= "contact";
      leadFormData.event_name	= "page_engagement";
      leadFormData.event = "form_failure";
      leadFormData.event_label	= "Contact-Form Failure";
      leadFormData.event_description	= "form_failure";
      leadFormData.event_page_location = UDO.NotSet;
      leadFormData.pagegroup	= "contact";
      leadFormData.page_element	= "form";
      // leadFormData.page_referral = 
      leadFormData.vin= data.leftRailVehicleData.Vin;
      leadFormData.hyperion_id = data.Hid;
      leadFormData.make = data.leftRailVehicleData.Make;
      leadFormData.make_yr = data.leftRailVehicleData.Year;
      leadFormData.model = data.leftRailVehicleData.Model;
      leadFormData.condition = data.leftRailVehicleData.InventoryVehicleDetail.StockType;
      // leadFormData.login_status = 
      // leadFormData.an_user_id =
      
      (window as any).utag_data = leadFormData;
      this.tealium.link((window as any).utag_data);      
    } catch (error) {
      console.log(error);
    }
  }

  reportValidationContactStoreFormFailure(data: string) {
    try {
      this.category_l1 = CategoryL1.Contact;
      this.category_l2 = CategoryL2.OEM;
      this.category_l3 = UDO.NotSet;
      this.category_l4 = data;
      const leadFormData: any = {};
      leadFormData.category_l1 = this.category_l1;
      leadFormData.category_l2 = this.category_l2;
      leadFormData.category_l3 = this.category_l3;
      leadFormData.category_l4 = this.category_l4;
      leadFormData.form_name = FormName.OEMReferral;
      leadFormData.form_actual_name = FormActualName.OEMContact;
      leadFormData.form_failure = 0;
      leadFormData.event_value = 1;
      leadFormData.event_type = "InternalActivity";
      leadFormData.event_action = "form";
      leadFormData.event_category = "contact";
      leadFormData.event_name = "page_engagement";
      leadFormData.event = "form_failure_validation";
      leadFormData.event_label = "Contact-Form Failure";
      leadFormData.event_page_location = UDO.NotSet;
      leadFormData.pagegroup = "contact";
      leadFormData.page_referral = UDO.NotSet;

      (window as any).utag_data = leadFormData;
      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  reportLogoClick(data) {
    try {
      this.category_l1 = CategoryL1.Contact;
      this.category_l2 = CategoryL2.OEM;
      this.category_l3 = data.isConfirm ? 'Confirmation' : UDO.NotSet; 
      this.category_l4 = UDO.NotSet;
      const leadFormData: any = {};
      leadFormData.category_l1 = this.category_l1;
      leadFormData.category_l2 = this.category_l2;
      leadFormData.category_l3 = this.category_l3;
      leadFormData.category_l4 = this.category_l4;
      leadFormData.event_value = 1;
      leadFormData.event_type	= "InternalActivity";
      leadFormData.event_action	= "click";
      leadFormData.event_category	= "home";
      leadFormData.event_name	= "site_engagement";
      leadFormData.event = "navigate_home";
      leadFormData.event_label	= "AutoNation";
      leadFormData.event_description	= "master_home_button";
      leadFormData.event_page_location = "hero";
      leadFormData.pagegroup	= "contact";
      leadFormData.page_element	= UDO.NotSet;
      // leadFormData.page_referral = 
      leadFormData.vin= data.leftRailVehicleData.Vin;
      leadFormData.hyperion_id = data.Hid;
      leadFormData.make = data.leftRailVehicleData.Make;
      leadFormData.make_yr = data.leftRailVehicleData.Year;
      leadFormData.model = data.leftRailVehicleData.Model;
      leadFormData.condition = data.leftRailVehicleData.InventoryVehicleDetail.StockType;
      // leadFormData.login_status = 
      // leadFormData.an_user_id =
      
      (window as any).utag_data = leadFormData;
      this.tealium.link((window as any).utag_data);      
    } catch (error) {
      console.log(error);
    }
  }

 /* istanbul ignore next */
  GetCustZipcode() {
    return (document.getElementById('zip_code') ? (document.getElementById('zip_code') as HTMLInputElement).value : '');
  }
}
